<template>
  <div class="archive-container">
    <div class="page-header">
      <h2>电子档案带</h2>
      <p>完善您的电子档案信息，便于更好地进行志愿填报规划</p>
      <p v-if="!isEditable" class="edit-tip">点击下方"编辑"按钮后可编辑档案内容</p>
    </div>

    <div v-if="loading" class="loading-container">
      <el-spin size="large" tip="加载中..."></el-spin>
    </div>

    <el-form
      v-else
      ref="formRef"
      :model="form"
      :rules="rules"
      label-width="120px"
      class="archive-form"
    >
      <div class="form-section">
        <h3 class="section-title">基本信息</h3>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="省份" prop="province">
              <el-select
                v-model="form.province"
                placeholder="请选择省份"
                filterable
                style="width: 100%"
                :disabled="!isEditable"
              >
                <el-option
                  v-for="item in provinces"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="性别" prop="gender">
              <el-radio-group v-model="form.gender" :disabled="!isEditable">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="2">女</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="选科组合" prop="subjectType">
              <el-select
                v-model="form.subjectType"
                placeholder="请选择选科组合"
                style="width: 100%"
                :disabled="!isEditable"
              >
                <el-option label="物理类" value="物理类" />
                <el-option label="历史类" value="历史类" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <h3 class="section-title">高考信息</h3>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="高考分数" prop="examScore">
              <el-input-number
                v-model="form.examScore"
                :min="0"
                :max="750"
                :precision="0"
                placeholder="请输入高考分数"
                style="width: 100%"
                :disabled="!isEditable"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="高考位次" prop="examRank">
              <el-input-number
                v-model="form.examRank"
                :min="1"
                placeholder="根据分数自动获取"
                style="width: 100%"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <h3 class="section-title">意向院校</h3>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="意向院校">
              <el-select
                v-model="form.schoolId"
                placeholder="请选择意向院校"
                filterable
                style="width: 100%"
                :disabled="!isEditable"
                @change="handleSchoolChange"
              >
                <el-option
                  v-for="school in schools"
                  :key="school.value"
                  :label="school.label"
                  :value="school.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
      </div>

      <div class="form-section">
        <h3 class="section-title">体检信息</h3>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="身高(cm)">
              <el-input
                v-model="form.height"
                type="number"
                placeholder="身高"
                style="width: 100%"
                :disabled="!isEditable"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="体重(kg)">
              <el-input
                v-model="form.weight"
                type="number"
                placeholder="体重"
                style="width: 100%"
                :disabled="!isEditable"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="视力">
              <el-input v-model="form.vision" placeholder="如: 5.0" style="width: 100%" :disabled="!isEditable" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="体检结论">
              <el-select
                v-model="form.medicalResult"
                placeholder="请选择体检结论"
                style="width: 100%"
                :disabled="!isEditable"
                allow-create
                filterable
              >
                <el-option label="合格" value="合格" />
                <el-option label="不合格" value="不合格" />
                <el-option label="待定" value="待定" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="政审结论">
              <el-select
                v-model="form.politicalReview"
                placeholder="请选择政审结论"
                style="width: 100%"
                :disabled="!isEditable"
                allow-create
                filterable
              >
                <el-option label="合格" value="合格" />
                <el-option label="不合格" value="不合格" />
                <el-option label="待定" value="待定" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="18"></el-col>
        </el-row>
      </div>

      <div class="form-actions">
        <el-button type="primary" @click="resetForm" :disabled="isEditable">编辑</el-button>
        <el-button type="success" :loading="submitting" @click="submitForm" :disabled="!isEditable || isSaved">
          {{ isSaved ? '已保存' : '保存档案' }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { ElMessage } from "element-plus";
import { getStudentProfile, saveStudentProfile } from "@/api/studentProfileApi";
import { getAllSchoolsWithMajors } from "@/api/schoolApi";
import { getRankByScore } from "@/api/processApi";

export default {
  name: "ElectronicArchive",
  setup() {
    const formRef = ref(null);
    const loading = ref(true);
    const submitting = ref(false);
    const schools = ref([]);
    const isEditable = ref(false);
    const isSaved = ref(false);

    const form = ref({
      province: "",
      city: "",
      gender: 1,
      subjectType: "",
      examScore: null,
      examRank: null,
      schoolId: null,
      schoolName: "",
      height: null,
      weight: null,
      vision: "",
      medicalResult: "",
      politicalReview: "",
    });

    const rules = {
      province: [{ required: true, message: "请选择省份", trigger: "change" }],
      gender: [{ required: true, message: "请选择性别", trigger: "change" }],
      subjectType: [{ required: true, message: "请选择选科组合", trigger: "change" }],
      examScore: [{ required: true, message: "请输入高考分数", trigger: "blur" }],
      examRank: [{ required: true, message: "请输入高考位次", trigger: "blur" }],
    };

    const provinces = [
      { value: "北京", label: "北京" },
      { value: "天津", label: "天津" },
      { value: "河北", label: "河北" },
      { value: "山西", label: "山西" },
      { value: "内蒙古", label: "内蒙古" },
      { value: "辽宁", label: "辽宁" },
      { value: "吉林", label: "吉林" },
      { value: "黑龙江", label: "黑龙江" },
      { value: "上海", label: "上海" },
      { value: "江苏", label: "江苏" },
      { value: "浙江", label: "浙江" },
      { value: "安徽", label: "安徽" },
      { value: "福建", label: "福建" },
      { value: "江西", label: "江西" },
      { value: "山东", label: "山东" },
      { value: "河南", label: "河南" },
      { value: "湖北", label: "湖北" },
      { value: "湖南", label: "湖南" },
      { value: "广东", label: "广东" },
      { value: "广西", label: "广西" },
      { value: "海南", label: "海南" },
      { value: "重庆", label: "重庆" },
      { value: "四川", label: "四川" },
      { value: "贵州", label: "贵州" },
      { value: "云南", label: "云南" },
      { value: "西藏", label: "西藏" },
      { value: "陕西", label: "陕西" },
      { value: "甘肃", label: "甘肃" },
      { value: "青海", label: "青海" },
      { value: "宁夏", label: "宁夏" },
      { value: "新疆", label: "新疆" },
    ];

    const loadProfile = async () => {
      try {
        const response = await getStudentProfile();
        if (response.data.code === 200 && response.data.data) {
          const data = response.data.data;
          form.value = {
            province: data.province || "",
            city: data.city || "",
            gender: data.gender || 1,
            subjectType: data.subjectType || "",
            examScore: data.examScore || null,
            examRank: data.examRank || null,
            schoolId: data.schoolId || null,
            schoolName: data.schoolName || "",
            height: data.height || null,
            weight: data.weight || null,
            vision: data.vision || "",
            medicalResult: data.medicalResult || "",
            politicalReview: data.politicalReview || "",
          };
          
          // 根据分数自动获取位次
          if (form.value.examScore) {
            await fetchRankByScore(form.value.examScore);
          }
        }
      } catch (error) {
        console.error("获取档案失败:", error);
      }
    };

    const loadSchools = async () => {
      try {
        const response = await getAllSchoolsWithMajors();
        if (response.data.code === 200) {
          const schoolList = response.data.data.list;
          schools.value = schoolList.map((school) => ({
            value: school.id,
            label: school.name,
          }));
        }
      } catch (error) {
        console.error("获取院校列表失败:", error);
        schools.value = [
          { value: 1, label: "国防科技大学" },
          { value: 2, label: "陆军工程大学" },
          { value: 3, label: "海军工程大学" },
          { value: 4, label: "空军工程大学" },
          { value: 5, label: "火箭军工程大学" },
        ];
      }
    };

    // 根据分数自动获取位次
    const fetchRankByScore = async (score) => {
      if (!score || score < 0) {
        form.value.examRank = null;
        return;
      }
      
      try {
        const response = await getRankByScore(score);
        if (response.data.code === 200 && response.data.data) {
          form.value.examRank = response.data.data.rank || null;
        }
      } catch (error) {
        console.error('获取位次失败:', error);
      }
    };

    // 监听分数变化，自动获取位次
    watch(
      () => form.value.examScore,
      (newScore) => {
        if (newScore) {
          fetchRankByScore(newScore);
        }
      }
    );

    const handleSchoolChange = (schoolId) => {
      const school = schools.value.find((s) => s.value === schoolId);
      if (school) {
        form.value.schoolName = school.label;
      }
    };

    const submitForm = async () => {
      if (!formRef.value) return;

      await formRef.value.validate(async (valid) => {
        if (valid) {
          submitting.value = true;
          try {
            const submitData = {
              province: form.value.province,
              city: form.value.city,
              gender: form.value.gender,
              subjectType: form.value.subjectType,
              examScore: form.value.examScore,
              examRank: form.value.examRank,
              schoolId: form.value.schoolId,
              schoolName: form.value.schoolName,
              height: form.value.height,
              weight: form.value.weight,
              vision: form.value.vision,
              medicalResult: form.value.medicalResult,
              politicalReview: form.value.politicalReview,
            };

            const response = await saveStudentProfile(submitData);
            if (response.data.code === 200) {
              ElMessage.success("档案保存成功");
              isSaved.value = true;
              isEditable.value = false;
            } else {
              ElMessage.error(response.data.msg || "保存失败");
            }
          } catch (error) {
            console.error("保存档案失败:", error);
            ElMessage.error("保存失败，请稍后重试");
          } finally {
            submitting.value = false;
          }
        }
      });
    };

    const resetForm = () => {
      // 点击重置按钮开启编辑模式
      isEditable.value = true;
      isSaved.value = false;
      ElMessage.info("已进入编辑模式，可修改档案内容");
    };

    const closeEdit = () => {
      // 关闭编辑模式
      isEditable.value = false;
      // 重新加载档案数据
      loadProfile();
    };

    onMounted(async () => {
      loading.value = true;
      await Promise.all([loadProfile(), loadSchools()]);
      loading.value = false;
    });

    return {
      formRef,
      form,
      rules,
      provinces,
      schools,
      loading,
      submitting,
      isEditable,
      isSaved,
      handleSchoolChange,
      submitForm,
      resetForm,
    };
  },
};
</script>

<style scoped>
.archive-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
}

.page-header {
  text-align: center;
  margin-bottom: 20px;
  padding-top: 10px;
}

.page-header h2 {
  font-size: 28px;
  color: #303133;
  margin-bottom: 10px;
  font-weight: 700;
}

.page-header p {
  color: #909399;
  font-size: 15px;
  margin-bottom: 6px;
}

.page-header .edit-tip {
  color: #409eff;
  font-size: 14px;
  margin-top: 4px;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60px;
}

.archive-form {
  background: #fff;
  border-radius: 12px;
  padding: 24px 30px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e8e8e8;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 10px;
}

.section-title {
  font-size: 18px;
  color: #303133;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 4px solid #409eff;
  font-weight: 600;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px dashed #e8e8e8;
}

.form-actions .el-button {
  min-width: 120px;
  padding: 12px 24px;
  font-size: 16px;
}

:deep(.el-form-item) {
  margin-bottom: 16px;
}

:deep(.el-form-item__label) {
  font-size: 15px;
  padding-right: 12px;
  line-height: 32px;
}

:deep(.el-form-item__content) {
  line-height: 32px;
}

:deep(.el-input__wrapper),
:deep(.el-select__wrapper),
:deep(.el-input-number) {
  font-size: 15px;
}

:deep(.el-input__inner),
:deep(.el-select__input) {
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  padding: 0 12px;
}

:deep(.el-select) {
  width: 100%;
}

:deep(.el-select__arrow) {
  font-size: 16px;
}

:deep(.el-radio) {
  font-size: 15px;
}

:deep(.el-radio__input) {
  margin-right: 4px;
}

:deep(.el-input-number) {
  width: 100%;
}

:deep(.el-input-number__btn) {
  width: 20px;
}

:deep(.el-input-number__increase),
:deep(.el-input-number__decrease) {
  height: 13px;
  line-height: 13px;
}

:deep(.el-input-number__increase) {
  border-bottom: 1px solid #dcdfe6;
}

@media (max-width: 1024px) {
  .archive-container {
    padding: 5px 15px;
    max-width: 100%;
  }

  .archive-form {
    padding: 10px 15px;
  }
}

@media (max-width: 768px) {
  .archive-container {
    padding: 5px 10px;
  }

  .archive-form {
    padding: 8px 12px;
  }

  :deep(.el-form-item) {
    margin-bottom: 4px;
  }

  :deep(.el-input__inner),
  :deep(.el-select__input) {
    height: 24px;
    line-height: 24px;
  }
}
</style>
